export const MAIN_COLOR = '#665dfe';
export const PRIMARY_COLOR = '#1975f9';
export const GRAY_COLOR = '#fafbfd';
export const DARK_GRAY_COLOR = '#495057';
export const LIGHT_GRAY_COLOR = '#e5e9f2';
export const INPUT_BORDER_COLOR = '#ced4da';
export const GREEN_COLOR = '#44a675';
export const RED_COLOR = '#ff337c';
